import { app } from '../../../../../../app';
import { Controller } from './edit-domain.controller';

app.component('companyDirectoryIntegrationManageDomainsEditDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domain: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-domain.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/edit-domain/edit-domain.component.js